import React from 'react';
import UserSelectSection from 'features/admin/sections/UserSelectSection';
import Header from 'features/shared/layout/header/Header';
import ModuleContent from 'features/shared/layout/content/ModuleContent';
import { useTranslation } from 'react-i18next';

interface Props {
  
}

const UserSelect = (props: Props) => {
  // translations
  const tLabels = useTranslation("shared\\moduleNames").t;

  // render
  return (
    <>
      <Header
          title={tLabels("userSelect.title")}
          includeBreadcrumbs
      />
      <ModuleContent>
        <UserSelectSection />
      </ModuleContent>
    </>
  )
}

export default UserSelect;
